import { nextLine, bold, nextParagraph } from "components/mlpaUiComponents/LegalNote/lib";
import { capitalize } from "lodash";

export default {
  label: "Fehlerberichte",
  errorDescription: "Fehlerbeschreibung",
  certificateCode: "ZEREZ ID",
  certificateHolder: "Zertifikatsinhaber",
  correctionExplanation: "Antwort/Erläuterung",
  status: "Status",
  errorType: "Fehlerart",
  reportedOn: "Gemeldet am",
  reportedBy: "Gemeldet von",
  resolvedOn: "Gelöst am",
  resolvedBy: "Gelöst von",
  openSince: "Offen seit (Tage)",
  totalErrorReports: "# Fehlerberichte",
  discardErrorReport: "Fehlerbericht verwerfen",
  closeErrorReportModalNote: ({
    firstName,
    lastName,
    email,
  }: {
    firstName?: string;
    lastName?: string;
    email?: string;
  }) => `Hallo ${capitalize(firstName) + (lastName && ` ${capitalize(lastName)}`)}, 
          ${nextLine()}soll dieser Fehlerbericht tatsächlich geschlossen werden?
          ${nextLine()}Diese Emailadresse wird für die weitere Bearbeitung hinterlegt: ${bold(email ?? "")}
          ${nextParagraph()}Eine schriftliche Begündung, warum dieser Fehlerbericht verworfen wird, ist zwingend erforderlich:`,

  errorReportClosedBy: ({ firstName, lastName, email }: { firstName?: string; lastName?: string; email?: string }) =>
    `geschlossen von ${capitalize(firstName) + (lastName && ` ${capitalize(lastName)}`)}: ${email ?? ""}`,
};
